"use client"

import { Link } from "react-router-dom"
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { ChevronRight } from "lucide-react"
import { useBreadcrumbs } from "@/hooks/useBreadcrumbs"
import React from "react"

/**
 * Renders a navigation breadcrumb trail with "MAP Apps Platform"
 */
export function NavigationBreadcrumb(): React.ReactElement {
  const crumbs = useBreadcrumbs()

  return (
    <Breadcrumb className="mt-0.75">
      <BreadcrumbList>
        <BreadcrumbItem>
          {crumbs.length === 0 ? (
            <BreadcrumbPage className="font-semibold">MAP Apps Platform</BreadcrumbPage>
          ) : (
            <BreadcrumbLink asChild>
              <Link to="/" className="text-muted-foreground hover:text-foreground/80 no-underline">
                MAP Apps Platform
              </Link>
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>

        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1

          return (
            <React.Fragment key={crumb.path}>
              <BreadcrumbSeparator>
                <ChevronRight />
              </BreadcrumbSeparator>

              <BreadcrumbItem>
                {isLast ? (
                  <BreadcrumbPage className="font-semibold no-underline">
                    {crumb.label}
                  </BreadcrumbPage>
                ) : crumb.isNavigable ? (
                  <BreadcrumbLink asChild>
                    <Link
                      to={crumb.path}
                      className="text-muted-foreground hover:text-foreground/80 no-underline"
                    >
                      {crumb.label}
                    </Link>
                  </BreadcrumbLink>
                ) : (
                  <span className="text-muted-foreground no-underline">{crumb.label}</span>
                )}
              </BreadcrumbItem>
            </React.Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
